import { useI18n } from '../../hooks/useI18nFormatters';
import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { theme } from '../../theme/theme';
import styles from './IndicatorBattery.module.css';

export function IndicatorBattery(props) {
  const { i18n } = useI18n();
  const [value, , capabilityObj] = useCapabilityValue({
    deviceId: props.device.id,
    capabilityId: props.capabilityId,
  });

  const percentage = getBatteryPercentage({ capabilityObj, value });

  const levelColor = getBatteryLevelColor({ capabilityObj, percentage, value });
  const label = getBatteryLabel({ capabilityObj, i18n, percentage, value });
  const levelWidth = getBatteryLevelWidth(percentage);
  const textColor = getBatteryTextColor({ capabilityObj, percentage, value });

  return (
    <div
      className={styles.root}
      style={{
        '--prop-battery-level-color': levelColor,
        '--prop-battery-level-width': levelWidth == null ? undefined : `${levelWidth}px`,
        '--prop-text-color': textColor,
      }}
    >
      <div className={styles.batteryIcon} aria-hidden={true}>
        <div className={styles.batteryBody}>
          <div className={styles.batteryLevel} data-has-percentage={percentage !== null} />
        </div>
        <div className={styles.batteryTerminal} />
      </div>
      <div className={styles.statusText}>{label}</div>
    </div>
  );
}

function getBatteryPercentage(props) {
  if (props.capabilityObj?.type === 'boolean') {
    switch (props.value) {
      case true:
        return 10;
      case false:
        return 100;
      default:
        return null;
    }
  }

  if (typeof props.value !== 'number') {
    return null;
  }

  return Math.max(0, Math.min(100, props.value));
}

function getBatteryLabel(props) {
  if (props.capabilityObj?.type === 'boolean') {
    switch (props.value) {
      case true:
        return props.i18n.messageFormatter('device.battery.low');
      case false:
        return props.i18n.messageFormatter('common.ok');
      default:
        return '-';
    }
  }

  if (props.percentage == null) {
    return '-';
  }

  return `${Math.round(props.percentage)}%`;
}

function getBatteryLevelColor(props) {
  if (props.capabilityObj?.type === 'boolean') {
    switch (props.value) {
      case true:
        return theme.color.error;
      case false:
        return theme.color.success;
      default:
        return theme.color.mono_300;
    }
  }

  if (props.percentage == null) {
    return theme.color.mono_300;
  }

  if (props.percentage <= 5) {
    return theme.color.error;
  }

  if (props.percentage <= 20) {
    return theme.color.orange;
  }

  if (props.percentage <= 40) {
    return theme.color.yellow;
  }

  return theme.color.success;
}

function getBatteryLevelWidth(percentage) {
  if (percentage == null) {
    return null;
  }

  return Math.max(2, Math.round((percentage / 100) * 15));
}

function getBatteryTextColor(props) {
  if (props.capabilityObj?.type === 'boolean') {
    if (props.value === true) {
      return theme.color.error;
    }

    return theme.color.mono_500;
  }

  if (props.percentage == null) {
    return theme.color.mono_500;
  }

  if (props.percentage <= 20) {
    return theme.color.error;
  }

  return theme.color.mono_500;
}
